module.exports = __webpack_public_path__ + "fonts/EuroStyleNormal.36fb681.woff2";